import { Menu } from "antd";
import type { MenuProps } from "antd";
import type { CSSProperties, ReactNode } from "react";

type AdminScopeSidebarProps = {
  title: ReactNode;
  selectedKey: string;
  items: NonNullable<MenuProps["items"]>;
  onSelect: (key: string) => void;
};

const ADMIN_SCOPE_SIDEBAR_STYLE: CSSProperties = {
  border: "1px solid var(--ant-colorBorderSecondary, #f0f0f0)",
  borderRadius: 8,
  padding: 8,
  background: "var(--ant-colorBgContainer, #fff)",
};

const ADMIN_SCOPE_SIDEBAR_TITLE_STYLE: CSSProperties = {
  padding: "4px 12px 8px",
  color: "var(--ant-colorTextSecondary, rgba(0, 0, 0, 0.45))",
  fontSize: 12,
  fontWeight: 600,
};

export function AdminScopeSidebar({
  title,
  selectedKey,
  items,
  onSelect,
}: AdminScopeSidebarProps) {
  return (
    <div style={ADMIN_SCOPE_SIDEBAR_STYLE}>
      <div style={ADMIN_SCOPE_SIDEBAR_TITLE_STYLE}>{title}</div>
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        items={items}
        onClick={({ key }) => {
          onSelect(String(key));
        }}
        style={{ borderInlineEnd: "none", background: "transparent" }}
      />
    </div>
  );
}
